import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";

import {fetchAuthSession} from "../../admin/auth/auth_client";
import {IStore} from "../../app/reducers/hybrid_reducer";
import {getUserOffers, setUserToStoreTypes} from "../Dashboard";

const useAuthorisation = () => {
    const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
    const [user, setUser] = useState<{id: number | null; displayName: string | null}>({id: null, displayName: null});
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [errMessage, setErrorMessage] = useState<string>("Brak autoryzacji !");
    const dispatch = useDispatch();
    const latestQuery = useSelector((store: IStore) => store.editOfferData.editOffer.latestQuery);

    useEffect(() => {
        fetchAuthSession(latestQuery.offerId)
            .then((session) => {
                setIsAuthenticated(session.authenticated);
                setUser(session.user);
                if (session.user.id) {
                    dispatch(getUserOffers(session.user.id));
                    dispatch({
                        type: setUserToStoreTypes.success,
                        result: {data: {user_id: session.user.id, displayName: session.user.displayName}}
                    });
                }
            })
            .catch((err) => {
                setErrorMessage(err instanceof Error ? err.message : "Brak autoryzacji !");
                setIsAuthenticated(false);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [dispatch, latestQuery.offerId]);

    return {isAuthenticated, user, isLoading, setIsAuthenticated, errMessage};
};

export default useAuthorisation;
